require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-dmp-data-platform.json") })
        }
      }, "path---services-dmp-data-platform");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-dmp-data-platform!./.cache/json/services-dmp-data-platform.json
// module id = 1481
// module chunks = 231608221292675